import {
	ChangeDetectionStrategy,
	ChangeDetectorRef,
	Component,
	HostBinding,
	Inject,
	Optional,
	ViewEncapsulation,
} from "@angular/core";
import {
	MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
	MatLegacyDialog as MatDialog,
} from "@angular/material/legacy-dialog";
import { Store } from "@ngrx/store";
import { AlertComponent, AlertOptions, MAT_CORE_CONFIG, MatCoreConfig } from "@obg/mat.ui.core";
import { DialogStatusAction } from "@obg/ngx.core";
import { CookieService } from "@obg/ngx.global.evo";
import { ComponentFactoryService } from "@obg/ngx.ui.core";

import { PUSH_MESSAGE } from "../push-message.const";

@Component({
	templateUrl: "./push-message-dialog.component.html",
	selector: "obg-m-push-message-dialog",
	styleUrls: ["./push-message-dialog.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
})
export class PushMessageDialogComponent extends AlertComponent {
	@HostBinding("class.obg-m-push-message-dialog") hostCssClass = true;

	constructor(
		@Inject(MAT_DIALOG_DATA) data: AlertOptions,
		@Optional() @Inject(MAT_CORE_CONFIG) coreConfig: MatCoreConfig,
		factoryService: ComponentFactoryService,
		changeDetector: ChangeDetectorRef,
		dialog: MatDialog,
		dialogStatusAction: DialogStatusAction,
		store: Store,
		private cookieService: CookieService
	) {
		super(data, coreConfig, factoryService, changeDetector, dialog, dialogStatusAction, store);
	}

	protected onClick(event: any) {
		if (!event?.target?.href) {
			return;
		}

		this.dialog.getDialogById(this.dialogId)?.close();
		this.cookieService.set({
			name: PUSH_MESSAGE.COOKIE_NAME,
			value: PUSH_MESSAGE.COOKIE_VALUE.OPEN_POPUP_NEXT_TIME,
		});
	}
}
